import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Button.scss';

const Button = ({children, theme, size, className, ...props}) => {
  const styleClassNames = classnames({
    'page-button': true,
    [`page-button--${theme}`]: !!theme,
    [`page-button--${size}`]: !!size,
    [className]: !!className,
  });
  return (
    <button type="button" {...props} className={styleClassNames}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['', 'gray', 'black']),
  size: PropTypes.oneOf(['', 'small']),
};

export default Button;
